import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { GroupedSwitcher } from '@monavate/ui-core';
import { RootState, useAppDispatch, useAppSelector } from '@/reduxStore/rootReducer';
import { hideExportModal } from '@/reduxStore/slices/exportSlice';
import { Modal } from '@monavate/ui-core';
import { downloadJson, downloadXlsx } from '@/helpers/exportJSON';
import { graphQLRequest } from '@/services/rest/entities/graphQLRequest';

const SwitcherContainer = styled.div`
    width: 50%;
`;

const switcherItems = [
    { label: 'JSON', value: 'json' },
    { label: 'XLSX', value: 'xlsx' },
];

interface ExportModalProps {
    isOpen: boolean;
}

const ExportModal: React.FC<ExportModalProps> = ({ isOpen }) => {
    const dispatch = useAppDispatch();
    const [selectedType, setSelectedType] = useState<string>('json');
    const query = useAppSelector((state: RootState) => state.export.query);
    const fileName = useAppSelector((state: RootState) => state.export.fileName);
    const [isLoading, setIsLoading] = useState(false);

    const handleClose = () => {
        dispatch(hideExportModal());
    };

    const handleSwitcherChange = (id: string) => {
        setSelectedType(id);
    };

    const handleExport = async () => {
        setIsLoading(true);
        const data = await graphQLRequest.postQuery(query, selectedType);

        if (selectedType === 'xlsx') {
            downloadXlsx(data, fileName);
        }
        if (selectedType === 'json') {
            downloadJson(data, fileName);
        }

        setIsLoading(false);
        dispatch(hideExportModal());
    };

    return (
        <Modal
            width={456}
            open={isOpen}
            title={'Export report'}
            onClose={handleClose}
            contentGap={16}
            submitTitle={'Export'}
            onSubmit={handleExport}
            isLoading={isLoading}
            disabledSubmit={isLoading}
        >
            Select the file type before exporting:
            <SwitcherContainer>
                <GroupedSwitcher
                    selectedItemId={selectedType}
                    items={switcherItems}
                    onChange={handleSwitcherChange}
                />
            </SwitcherContainer>
        </Modal>
    );
};

export default ExportModal;
